import {Router} from '@angular/router';

export interface ItemStateInfo {
  label?: string;
  state: any;
}

/**
 * TODO: refactor this in a ExplorerItem and Node-type
 */
export interface ExplorerItem {
  label: string;
  description?: string;
  value: any;
  stateInfo?: ItemStateInfo;
  children?: ExplorerItem[];
  expanded: boolean;
  allowedActions: any[];
  equals?: (item: ExplorerItem) => boolean;
  filter?: string[];
}

export interface ControlOption {
  callback: object;
  label: string;
}

export interface MenuItem {
  sticky?: boolean;
  label?: string;
  icon?: string;
  command?: (event?: any) => void;
  items?: MenuItem[];
  title?: string;
}

export interface TreeNodeInfo {
  item: ExplorerItem;
  nodeLevel: number;
  isCustom: boolean;
  processed: boolean;
  params?: any;
}

export interface LinkItem {
  label: string;
  navigate: (router: Router) => void;
  raw?: any;
  children?: LinkItem[];
  resourceUri?: string;
}

export enum StyleType {
  default,
  alert,
  success,
  warning,
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/types.ts